
    var instaslider = new Swiper(".instaslider", {
        loop: true,
        autoplay: true,
        speed: 600,
        slidesPerView: 5,
        spaceBetween: 10,
        centeredSlides: true,
        roundLengths: true,
        // If we need pagination

        breakpoints: {
            1024: {
                slidesPerView: 5,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            375: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
        },

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            // type: 'fraction'
        },

        // And if we need scrollbar
        scrollbar: {
            el: ".swiper-scrollbar",
        },
    });


    document.addEventListener("DOMContentLoaded", function () {
    const firstMenuItem = document.querySelector(
        "#menu-mb__ul > li.t4s-menu-item-has-children"
    );

    if (firstMenuItem) {
        firstMenuItem.classList.add("is--opend");

        const subMenu = firstMenuItem.querySelector(".t4s-sub-menu");
        if (subMenu) {
            subMenu.style.display = "block";
        }

        // icon click par close hone se rokna
        const toggleLink = firstMenuItem.querySelector("a");
        if (toggleLink) {
            toggleLink.addEventListener("click", function (e) {
                e.preventDefault();
            });
        }
    }
});